'use client';

import { useEffect, useRef, useState } from 'react';
import PlayVideoIcon from './PlayVideoIcon';

type VideoClipProps = {
  mediaItemUrl: string;
  autoplay?: boolean;
  controls?: boolean;
  loop?: boolean;
  muted?: boolean;
};

const VideoClip = ({
  mediaItemUrl,
  autoplay,
  controls,
  loop = true,
  muted = true,
}: VideoClipProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(autoplay && muted);

  const handleOnClick = () => {
    if (!controls && !autoplay) {
      setIsPlaying((prev) => !prev);
    }
  };

  useEffect(() => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  }, [isPlaying]);
  return (
    <div className={`relative overflow-hidden`} onClick={() => handleOnClick()}>
      {!controls && !isPlaying ? (
        <div className="w-full h-full absolute flex justify-center items-center bg-black bg-opacity-20 z-30 top-0">
          <button aria-label="Play video" className="cursor-pointer">
            <PlayVideoIcon className="w-16 h-16 text-white" />
          </button>
        </div>
      ) : null}
      <video
        ref={videoRef}
        autoPlay={autoplay}
        controls={controls}
        loop={loop}
        muted={muted}
        playsInline
        className={`w-full h-full`}
      >
        <source src={`${mediaItemUrl}#t=0.001`} type="video/mp4" />
      </video>
    </div>
  );
};

export default VideoClip;
